import { create } from 'zustand'

interface Toast {
  id: string
  type: 'success' | 'error' | 'info'
  message: string
}

interface UiStore {
  sidebarOpen: boolean
  theme: 'dark' | 'light'
  language: 'zh' | 'en'
  toasts: Toast[]
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
  setTheme: (t: 'dark' | 'light') => void
  setLanguage: (l: 'zh' | 'en') => void
  pushToast: (type: Toast['type'], message: string) => void
  dismissToast: (id: string) => void
}

export const useUiStore = create<UiStore>((set) => ({
  sidebarOpen: false,
  theme: 'dark',
  language: 'zh',
  toasts: [],
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setTheme: (theme) => set({ theme }),
  setLanguage: (language) => set({ language }),
  pushToast: (type, message) => {
    const id = Math.random().toString(36).slice(2)
    set((s) => ({ toasts: [...s.toasts, { id, type, message }] }))
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
    }, 3200)
  },
  dismissToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))
